module.exports = ['navigation', 'request', 'process', 'log', 'user', 'state', 'error', 'manual']
